import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy path. Permanent (301) redirect to the canonical /education hub so
// search engines consolidate any historic link equity onto the new URL.
export const Route = createFileRoute("/academy")({
  beforeLoad: () => {
    throw redirect({ to: "/education", statusCode: 301 });
  },
});
